// @ts-nocheck
import React, { useState } from 'react';

const QUESTIONS = [
  {
    key: 'primaryChallenge',
    question: 'What challenges you most?',
    options: [
      { value: 'career_money',   label: 'Career / Money' },
      { value: 'relationships',  label: 'Relationships' },
      { value: 'health_body',    label: 'Health / Body' },
      { value: 'inner_peace',    label: 'Inner Peace' },
      { value: 'purpose',        label: 'Purpose' },
    ],
  },
  {
    key: 'shadowPattern',
    question: 'What holds you back?',
    options: [
      { value: 'perfectionism',     label: 'Perfectionism / Self-doubt' },
      { value: 'fear_avoidance',    label: 'Fear / Avoidance' },
      { value: 'people_pleasing',   label: 'People-pleasing' },
      { value: 'anger_reactivity',  label: 'Anger / Reactivity' },
      { value: 'numbness',          label: 'Numbness / Disconnection' },
    ],
  },
  {
    key: 'spiritualStage',
    question: 'Where are you on your inner journey?',
    options: [
      { value: 'just_starting',         label: 'Just starting' },
      { value: 'some_experience',        label: 'Some experience' },
      { value: 'regular_practitioner',   label: 'Regular practitioner' },
      { value: 'deep_seeker',            label: 'Deep seeker' },
    ],
  },
];

export default function BoardQuestionnaire({ introAnswer, onComplete }) {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [openAnswer, setOpenAnswer] = useState(introAnswer ?? '');
  const [loading, setLoading] = useState(false);

  const isLastPreset = step === QUESTIONS.length - 1;
  const isOpenStep = step === QUESTIONS.length;

  const handleOption = (key, value) => {
    const updated = { ...answers, [key]: value };
    setAnswers(updated);
    if (!isLastPreset) {
      setStep(s => s + 1);
    } else {
      setStep(QUESTIONS.length); // open text step
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    onComplete({ ...answers, openAnswer: openAnswer.trim() });
  };

  const currentQ = QUESTIONS[step];
  const progressPct = Math.round((step / QUESTIONS.length) * 100);

  return (
    <>
      <div style={styles.bg} />
      <div style={styles.container}>

        {/* Progress bar */}
        <div style={styles.progressWrap}>
          <div style={{ ...styles.progressBar, width: `${progressPct}%` }} />
        </div>

        {/* Dots */}
        <div style={styles.dots}>
          {[0, 1, 2, 3].map(i => (
            <div key={i} style={{ ...styles.dot, background: i <= step ? '#C9920A' : 'rgba(201,146,10,0.2)' }} />
          ))}
        </div>

        <div style={styles.card}>
          {!isOpenStep ? (
            <>
              <h2 style={styles.question}>{currentQ.question}</h2>
              <div style={styles.optionList}>
                {currentQ.options.map(opt => (
                  <button
                    key={opt.value}
                    style={{ ...styles.optionBtn, ...(answers[currentQ.key] === opt.value ? styles.optionBtnSelected : {}) }}
                    onClick={() => handleOption(currentQ.key, opt.value)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </>
          ) : (
            <>
              <h2 style={styles.question}>In your own words, what would you like to transform?</h2>
              <textarea
                style={styles.textarea}
                value={openAnswer}
                onChange={e => setOpenAnswer(e.target.value)}
                placeholder="Describe what you'd like to change or explore..."
                rows={5}
                autoFocus
              />
              <button
                style={{ ...styles.submitBtn, opacity: loading ? 0.7 : 1 }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? 'Building your board...' : 'Create my personal board'}
              </button>
            </>
          )}
        </div>

        {step > 0 && (
          <button style={styles.backBtn} onClick={() => setStep(s => s - 1)}>
            ← Back
          </button>
        )}
      </div>
    </>
  );
}

const styles = {
  bg: { position: 'fixed', inset: 0, background: '#0D0D2B', zIndex: -1 },
  container: {
    minHeight: '100vh', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', padding: '40px 20px',
  },

  progressWrap: {
    width: '100%', maxWidth: '420px', height: '3px',
    background: 'rgba(201,146,10,0.15)', borderRadius: '2px',
    marginBottom: '20px', overflow: 'hidden',
  },
  progressBar: {
    height: '100%', background: '#C9920A', borderRadius: '2px',
    transition: 'width 0.4s ease',
  },

  dots: { display: 'flex', gap: '8px', marginBottom: '28px' },
  dot: {
    width: '10px', height: '10px', borderRadius: '50%',
    transition: 'background 0.3s',
  },

  card: {
    background: '#1E1145', border: '1px solid rgba(201,146,10,0.25)',
    borderRadius: '20px', padding: '40px 32px',
    maxWidth: '420px', width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
  },

  question: {
    fontFamily: '"Cinzel", serif', fontSize: '20px', fontWeight: '700',
    color: '#F5F0E8', marginTop: 0, marginBottom: '24px', textAlign: 'center',
    lineHeight: '1.4',
  },

  optionList: { display: 'flex', flexDirection: 'column', gap: '10px' },
  optionBtn: {
    width: '100%', padding: '14px 18px', textAlign: 'left',
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(201,146,10,0.2)',
    borderRadius: '12px', color: '#F5F0E8', fontSize: '15px',
    fontFamily: '"Lato", sans-serif', cursor: 'pointer',
    transition: 'all 0.15s',
  },
  optionBtnSelected: {
    background: 'rgba(201,146,10,0.15)', border: '1px solid rgba(201,146,10,0.6)',
    color: '#C9920A',
  },

  textarea: {
    width: '100%', padding: '14px', fontSize: '15px',
    border: '1px solid rgba(201,146,10,0.25)', borderRadius: '12px',
    background: 'rgba(255,255,255,0.05)', color: '#F5F0E8',
    fontFamily: '"Lato", sans-serif', boxSizing: 'border-box',
    outline: 'none', resize: 'vertical', lineHeight: '1.6',
    marginBottom: '20px',
  },

  submitBtn: {
    width: '100%', padding: '15px', background: '#C9920A',
    border: 'none', borderRadius: '12px', fontSize: '16px',
    fontWeight: '700', color: '#0D0D2B', cursor: 'pointer',
    fontFamily: '"Lato", sans-serif',
  },

  backBtn: {
    marginTop: '20px', background: 'none', border: 'none',
    color: 'rgba(201,146,10,0.7)', fontSize: '14px',
    cursor: 'pointer', textDecoration: 'underline', padding: '4px 0',
  },
};
